import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";

export default function ConfirmDialog({ open, onClose, onConfirm, title, description, confirmText = "Onayla", destructive = false, testId = "confirm-dialog" }) {
    return (
        <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
            <AlertDialogContent data-testid={testId}>
                <AlertDialogHeader>
                    <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
                    <AlertDialogDescription>{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel data-testid={`${testId}-cancel`}>Vazgeç</AlertDialogCancel>
                    <AlertDialogAction asChild>
                        <Button
                            onClick={onConfirm}
                            className={destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : "bg-terra-600 text-white hover:bg-terra-700"}
                            data-testid={`${testId}-confirm`}
                        >
                            {confirmText}
                        </Button>
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
